<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="18px"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1326 5097 c-22 -12 -48 -34 -58 -48 -28 -37 -250 -607 -256 -656 -8
-71 15 -131 72 -188 l51 -51 313 -98 c272 -85 320 -98 366 -94 64 5 109 34
136 88 38 74 16 173 -47 218 -24 17 -119 51 -290 104 -18 5 -33 11 -33 14 0 8
116 62 210 97 422 161 864 187 1300 77 154 -38 258 -77 415 -154 589 -289
1017 -843 1149 -1487 127 -617 -27 -1261 -421 -1763 -82 -104 -274 -291 -385
-374 -799 -599 -1895 -571 -2660 68 -739 616 -974 1665 -569 2537 57 123 62
158 29 223 -52 103 -178 129 -266 55 -79 -67 -229 -480 -276 -760 -154 -923
213 -1843 959 -2405 350 -263 731 -418 1190 -482 119 -17 494 -16 615 1 298
41 525 109 785 236 647 315 1136 914 1315 1612 55 218 74 371 73 623 0 259
-19 414 -79 640 -181 686 -671 1283 -1309 1594 -634 310 -1366 336 -2027 72
-60 -24 -108 -42 -108 -42 0 1 14 37 30 79 17 43 30 94 30 113 0 130 -143 215
-254 151z"
      />
      <path
        d="M2195 3496 c-38 -17 -80 -62 -94 -99 -15 -40 -15 -1048 0 -1119 39
-184 203 -344 388 -378 29 -6 213 -10 408 -10 384 0 393 1 445 56 65 70 65
168 0 238 -52 55 -61 56 -439 56 -388 0 -395 1 -440 69 l-23 34 0 511 c0 574
1 564 -75 621 -43 34 -122 44 -170 21z"
      />
    </g>
  </svg>
</template>
